export default function DocsStandardPages(){
  return(
    <div>
      Document Standard Pages coming soon! 
    </div>
  );
}